import { debug } from 'svelte/internal';
import { writable, derived, readable, get } from 'svelte/store';

/** Store for your data. 
This assumes the data you're pulling back will be an array.
If it's going to be an object, default this to an empty object.
**/
export const apiData = writable({});

export const projects = writable({}); // The projects store for selecting between projects

export const apiDataDashboard = writable({}); // 12185

export const apiDataDashboard12975 = writable({});

export const apiDataDashboard12976 = writable({});

export const apiDataDashboard13003 = writable({});

export const apiDataDashboard13009 = writable({});
export const apiDataDashboard13013 = writable({});
export const apiDataDashboard13016 = writable({});
export const apiDataDashboard13011 = writable({});
export const apiDataDashboard13012 = writable({});
export const apiDataDashboard13024 = writable({});
export const apiDataDashboard13036 = writable({});

export const apiLoading = writable(false);

const baseURL = window.location.origin;
const SCFAPIBase = baseURL + '/wp-json/scf-data/v1/';

export function getDashboard(dashboardRequest, projectRef = null) {
    dashboardRequest.store.set({});
    const nonce = scf_client_portal.nonce;
    if ( projectRef == 'all' ) {
        projectRef = null;
    }
    const requestURL = SCFAPIBase + "project-dashboard-by-dashboard-id/" + dashboardRequest.id+ "?project_ref=" + projectRef;
    // console.log('getDashboard -> requestURL', requestURL);
    fetch( requestURL, {
        headers: new Headers({
            'X-WP-Nonce': nonce
        })
    })
    .then(response => response.json())
    .then(data => {
        // console.log('getDashboard -> Dashboard -> ' + dashboardRequest.name, JSON.parse(data));
        dashboardRequest.store.set(JSON.parse(data));
        // console.log(get(apiLoading));
        apiLoading.set(false);
        // console.log(get(apiLoading));
    }).catch(error => {
        console.log('Dashboard Request Error - ' + dashboardRequest.name, error);
        apiLoading.set(false);
        return [];
    });
}
